import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const ProvablyFairModalLazy = React.lazy(() =>
  import('./ProvablyFairModal').then((m) => ({ default: m.ProvablyFairModal })),
);
type ProvablyFairModalProps = React.ComponentProps<
  typeof import('./ProvablyFairModal').ProvablyFairModal
>;

NiceModal.register(
  MODALS.PROVABLY_FAIR,
  NiceModal.create((props: ProvablyFairModalProps) => (
    <Suspense fallback={null}>
      <ProvablyFairModalLazy {...props} />
    </Suspense>
  )),
);
